import { useMutation, useQuery } from "@tanstack/react-query";
import { Invoice, IPlan, IProration } from "~/types/billing";
import { INVOICES, PLANS, PRORATION } from "./types";
import {
  shopifySubscription,
  getPlans,
  stripeSubscription,
  updateCard,
  cancelSubscription,
  getInvoices,
  getProration,
  stripeIntent,
  cancellationInfo,
  paypalSubscription,
} from "./requests";

export const usePlans = () =>
  useQuery<Array<IPlan>>(PLANS, getPlans, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

export const useInvoices = () =>
  useQuery<Array<Invoice>>(INVOICES, () => getInvoices());

export const useShopifySubscription = () => useMutation(shopifySubscription);

export const usePaypalSubscription = () => useMutation(paypalSubscription);

export const useStripeSubscription = () => useMutation(stripeSubscription);

export const useStripeIntent = () => useMutation(stripeIntent);

export const useUpdateCard = () => useMutation(updateCard);

export const useCancelSubscription = () => useMutation(cancelSubscription);

export const useProrationValue = (planId?: string, promoCodeId?: string) =>
  useQuery<IProration>(
    [PRORATION, planId],
    () => getProration(planId, promoCodeId),
    // Without a plan id the request is proration/undefined, a guaranteed 404.
    { enabled: !!planId }
  );

export const useCancellationInfo = () => useMutation(cancellationInfo);
